var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import { useTypedSelector } from "../../state/store";
import { SpaciousPaper, WhiteSpacePreservingTypography } from "../styleComponents";
import MarkdownText from "../MarkdownText";
var AnswerPaper = styled(SpaciousPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 2rem;\n  ", "\n"], ["\n  margin-bottom: 2rem;\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});

var PeerReviewOption = function PeerReviewOption(_a) {
  var answer = _a.answer;
  var themeProvider = useContext(ThemeProviderContext);
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });

  if (!quiz) {
    return React.createElement("div", null);
  }

  var quizItems = quiz.items;

  var quizItemById = function quizItemById(id) {
    return quizItems.find(function (qi) {
      return qi.id === id;
    });
  };

  return React.createElement("div", {
    style: {
      padding: ".5rem 1rem"
    }
  }, answer.itemAnswers.filter(function (ia) {
    return quizItemById(ia.quizItemId);
  }).sort(function (ia1, ia2) {
    var qi1 = quizItemById(ia1.quizItemId);
    var qi2 = quizItemById(ia2.quizItemId);

    if (!qi1 || !qi2) {
      return -1;
    }

    return qi1.order - qi2.order;
  }).map(function (ia) {
    var _a;

    var quizItem = quizItemById(ia.quizItemId);
    var quizTitle = quizItem ? quizItem.title : "";
    var chosenOptions = null;

    if (ia.optionAnswers && ia.optionAnswers.length > 0) {
      var selectedQuizOptionIds_1 = ia.optionAnswers.map(function (oa) {
        return oa.quizOptionId;
      });
      var selectedOptions = (_a = quizItem === null || quizItem === void 0 ? void 0 : quizItem.options) === null || _a === void 0 ? void 0 : _a.filter(function (option) {
        return selectedQuizOptionIds_1.includes(option.id);
      });

      if (selectedOptions && selectedOptions.length > 0) {
        chosenOptions = selectedOptions.map(function (o) {
          return o.title;
        }).join(", ");
      }
    }

    return React.createElement(React.Fragment, {
      key: ia.id
    }, React.createElement(MarkdownText, null, quizTitle), React.createElement(AnswerPaper, {
      key: ia.id,
      providedStyles: themeProvider.answerPaperStyles
    }, chosenOptions && React.createElement(WhiteSpacePreservingTypography, {
      variant: "body1"
    }, chosenOptions), ia.textData && React.createElement(WhiteSpacePreservingTypography, {
      variant: "body1"
    }, ia.textData)));
  }));
};

export default PeerReviewOption;
var templateObject_1;